import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Modal, Form, Row, Col, Table, Dropdown } from 'react-bootstrap';
import { MdAirplaneTicket, MdLandslide, MdMoneyOff, MdOutlineDiscount, MdOutlineSupport, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCodePromosAll, fetchCodePromosOfIdUserAll, createPromoCode, fetchCodePromoByUpdateId, fetchCodePromoById } from '../../../actions/request/CodePromoRequest';
import { getAndCheckLocalStorage } from '../../../utils/storage/localvalueFuction';
import { localStorageKeys } from '../../../utils/storage/localvalue';
import { toast } from 'react-toastify';
import { RiFileDamageFill } from 'react-icons/ri';
import { CompanyAiportCreate, CompanyAiportUpdatById, fetchCompanyAiportsAll } from '../../../actions/request/CompanyAiportRequest';
import { fetchExpenseCategorysAll } from '../../../actions/request/ExpenseCategoryRequest';
import { MaintenanceCreate, MaintenanceUpdateById } from '../../../actions/request/MaintenanceRequest';
import { MaintenanceCategoryCreate, MaintenanceCategoryUpdateById, fetchMaintenanceCategorysAll } from '../../../actions/request/MaintenanceCategoryRequest';
import { FaTools } from 'react-icons/fa';
import { patrimoineTypes } from '../../../utils/dataApi/dataFormApi';
import { fetchCategoryExpenseBigsAll } from '../../../actions/request/CategoryExpnsesBigRequest';

const MaintenanceTypePage = () => {


    const dispatch = useDispatch();
    const { categoryexpensebigs } = useSelector((state) => state.categoryexpensebigs);
    const maintenanceCategorys = useSelector((state) => state.maintenanceCategorys.maintenanceCategorys);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [promoCodeData, setPromoCodeData] = useState({
        name: '',
        description: '',
        patrimoine: "",
        categoryexpensebig: ''
    });
    const [selectedPromoCode, setSelectedPromoCode] = useState(null);
    const [showCode, setShowCode] = useState({});
    const itemsPerPage = 50;

    
    useEffect(() => {
        dispatch(fetchCategoryExpenseBigsAll());
        dispatch(fetchMaintenanceCategorysAll());
    }, [dispatch]);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setPromoCodeData({ name: "", description: "", categoryexpensebig: "" });
        setSelectedPromoCode(null);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPromoCodeData((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleCreateOrUpdatePromoCode = () => {
        if (selectedPromoCode) {
            if (!promoCodeData.name && !promoCodeData.description && !promoCodeData.patrimoine && !promoCodeData.categoryexpensebig) {
                toast.error("Veillez renseignez tous les champs s'il vous plait . ", { position: "bottom-right" })
                return;
            }
            dispatch(MaintenanceCategoryUpdateById(selectedPromoCode?._id, promoCodeData));
        }
        else {
            // const userAdd = getAndCheckLocalStorage(localStorageKeys.userId);
            if (!promoCodeData.name && !promoCodeData.description && !promoCodeData.patrimoine) {
                toast.error("Veillez renseignez tous les champs s'il vous plait . ", { position: "bottom-right" })
                return;
            }
            dispatch(MaintenanceCategoryCreate({ ...promoCodeData }));
        }
        handleCloseModal();
    };

    const handleEditPromoCode = (promoCode) => {
        setSelectedPromoCode(promoCode);
        setPromoCodeData({
            name: promoCode.name,
            description: promoCode.description,
            patrimoine: promoCode.patrimoine,
            categoryexpensebig: promoCode?.categoryexpensebig?._id
        });
        handleShowModal();
    };

    const handleValidatePromoCode = (code) => {
        dispatch(fetchCodePromoById(code));
    };

    const handleToggleShowCode = (promoId) => {
        setShowCode((prevState) => ({ ...prevState, [promoId]: !prevState[promoId] }));
    };

    const paginatedPromoCodes = maintenanceCategorys.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) || [];



    return (
        <div>
            <Card>
                <Card.Header>
                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <h3 className="mb-4"><FaTools /> Catégories d{"'"}entretiens et réparations </h3>
                        </div>
                        <div>
                            <Button title="Ajouter une nouvelle catégorie de maintenance"
                                variant="primary"
                                size='sm'
                                className="ml-2"
                                onClick={handleShowModal}
                            >
                                + Ajouter
                            </Button>
                        </div>
                    </div>
                </Card.Header>

                <Card.Body style={{ minHeight: "400px" }} >
                    {paginatedPromoCodes && paginatedPromoCodes.length > 0 ? (
                        <div className="align-content-between">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Titre</th>
                                        <th>Options</th>
                                        <th>Catégorie</th>
                                        <th>Description</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedPromoCodes.map((promo) => (
                                        <tr key={promo._id}>
                                            <td>
                                                {promo?.name || ""}
                                            </td>
                                            <td>{promo?.patrimoine == "VEHICLE" ? "Véhicule" : "Propriété" || ""}</td>
                                            <td>{promo?.categoryexpensebig?.name || ""}</td>
                                            <td>{promo?.description || ""}</td>
                                            <td>
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="primary" size="sm">
                                                        Actions
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => handleEditPromoCode(promo)}>Modifier</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <div className="d-flex justify-content-start mt-4">
                                <Button
                                    variant="primary"
                                    size="sm" className="p-2"
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                    Précédent
                                </Button>
                                <Button
                                    variant="primary"
                                    size="sm" className="p-2"
                                    disabled={currentPage * itemsPerPage >= maintenanceCategorys.length}
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                >
                                    Suivant
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <Alert variant="light" style={{ display: "flex", justifyContent: "center" }}>Aucun catégorie</Alert>
                    )}
                </Card.Body>
            </Card>

            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedPromoCode ? "Modifier catégorie de maintenance" : "Nouveau catégorie de maintenance"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="discountPercentage">
                            <Form.Label>Titre<span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                style={{ height: "40px" }}
                                type="text"
                                name="name"
                                placeholder=''
                                value={promoCodeData.name}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group controlId="expiryDate">
                            <Form.Label>Option <span className="text-danger">*</span></Form.Label>
                            <Form.Select
                                name="patrimoine" className="border rounded-md"
                                value={promoCodeData.patrimoine}
                                onChange={handleInputChange}
                            >
                                <option value="">-- Sélectionnez --</option>
                                {
                                    patrimoineTypes.map((item) => {
                                        return (
                                            <option selected={promoCodeData.patrimoine == item.type ? true : false} value={item.type}>{item.name}</option>
                                        )
                                    })
                                }                </Form.Select>
                        </Form.Group>

                        <Form.Group controlId="expiryDate">
                            <Form.Label>Catégorie <span className="text-danger">*</span></Form.Label>
                            <Form.Select
                                name="categoryexpensebig" className="border rounded-md"
                                value={promoCodeData.categoryexpensebig}
                                onChange={handleInputChange}
                            >
                                <option value="">-- Sélectionnez --</option>
                                {
                                    categoryexpensebigs && categoryexpensebigs.length > 0 && categoryexpensebigs.map((item) => {
                                        return (
                                            <option selected={promoCodeData.categoryexpensebig == item._id ? true : false} value={item._id}>{item.name}</option>
                                        )
                                    })
                                }
                            </Form.Select>
                        </Form.Group>



                        <Form.Group controlId="expiryDate">
                            <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                as={"textarea"}
                                style={{ height: "50px" }}
                                type="text"
                                name="description"
                                value={promoCodeData.description}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" size="sm" onClick={handleCloseModal}>Annuler</Button>
                    <Button variant="primary" size="sm" onClick={handleCreateOrUpdatePromoCode}>{selectedPromoCode ? 'Mettre à Jour' : 'Créer'}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default MaintenanceTypePage;